export const SITE_TYPE = "WIX";
